import type { SlideDef } from "@/engine/types";
import { SerpDemoSlide } from "./01-serp-demo";
import { HatsSlide } from "./02-hats";
import { HatSortingSlide } from "./03-hat-sorting";
import { NegativeSeoSlide } from "./04-negative-seo";
import { QualityRatersSlide } from "./05-quality-raters";

export const slides: SlideDef[] = [
  {
    id: "c6-serp-demo",
    chapter: 6,
    title: "Demo: SERP positions — realistic expectations",
    component: SerpDemoSlide,
  },
  {
    id: "c6-hats",
    chapter: 6,
    title: "White-hat, grey-hat, black-hat",
    component: HatsSlide,
  },
  {
    id: "c6-hat-sorting",
    chapter: 6,
    title: "Demo: Sort the tactics",
    component: HatSortingSlide,
  },
  {
    id: "c6-negative-seo",
    chapter: 6,
    title: "Negative SEO: recognize and defend",
    component: NegativeSeoSlide,
  },
  {
    id: "c6-quality-raters",
    chapter: 6,
    title: "Search quality raters and guidelines",
    component: QualityRatersSlide,
  },
];
